import { useRef } from 'react';

import { useInteractiveCallback } from '@/hook/useInteractiveCallback';

import { useAppDispatch, useAppSelector } from '../store';

import { ApplicationSliceState } from './application.type';
import { setIsOnline, APPLICATION_REDUCER_NAME } from './application.slice';

// SELECTORS
export function useApplication() {
    return useAppSelector((state) => state[APPLICATION_REDUCER_NAME]);
}

export function useIsOnline() {
    const isOnline = useAppSelector(
        (state) => state[APPLICATION_REDUCER_NAME].isOnline,
    );

    const isOnlineRef = useRef<boolean | undefined>(undefined);

    isOnlineRef.current = isOnline;

    return { isOnline, isOnlineRef };
}

// DISPATCHERS
export function useSetIsOnline() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((data: ApplicationSliceState['isOnline']) => {
        dispatch(setIsOnline(data));
    });
}
